export interface FonteDadosProxyParametro {
  valor: any;
  rotulo: string;
  titulo: string;
  nome: any;
  obrigatorio: boolean;
  tipo: FonteDadosProxyParametroTipo;
  categoria: string;

  key(): string;
}

export abstract class FonteDadosProxyParametroAbstract implements FonteDadosProxyParametro {

  private readonly pNome: string;
  private pTitulo?: string;
  private pRotulo?: string;
  private pValor: any;
  private readonly pObrigatorio: boolean;
  private readonly pCategoria: string;
  private pTipo: FonteDadosProxyParametroTipo = FonteDadosProxyParametroTipo.TEXTO;

  protected constructor(nome: string, obrigatorio: boolean, categoria: 'path' | 'query' | 'body') {
    this.pNome = nome;
    this.pObrigatorio = obrigatorio;
    this.pCategoria = categoria;
  }

  get valor(): any {
    return this.pValor;
  }

  set valor(value: any) {
    this.pValor = value;
  }

  get rotulo(): string {
    return this.pRotulo ? this.pRotulo : this.pNome;
  }

  set rotulo(value: string) {
    this.pRotulo = value;
  }

  get titulo(): string {
    return this.pTitulo;
  }

  set titulo(value: string) {
    this.pTitulo = value;
  }

  get nome(): string {
    return this.pNome;
  }

  get obrigatorio(): boolean {
    return this.pObrigatorio;
  }

  get tipo(): FonteDadosProxyParametroTipo {
    return this.pTipo;
  }

  set tipo(value: FonteDadosProxyParametroTipo) {
    this.pTipo = value;
  }

  get categoria(): string {
    return this.pCategoria;
  }

  key(): string {
    return this.categoria + ':' + this.nome;
  }

}

export class FonteDadosProxyParametroPath extends FonteDadosProxyParametroAbstract {
  ordem: number;

  constructor(nome: string, ordem: number, obrigatorio: boolean) {
    super(nome, obrigatorio, 'path');
    this.ordem = ordem;
  }
}

export class FonteDadosProxyParametroQuery extends FonteDadosProxyParametroAbstract {
  constructor(nome: string, obrigatorio: boolean) {
    super(nome, obrigatorio, 'query');
  }
}

export class FonteDadosProxyParametroBody extends FonteDadosProxyParametroAbstract {
  constructor(nome: string, obrigatorio: boolean) {
    super(nome, obrigatorio, 'body');
  }

}

export enum FonteDadosProxyParametroTipo {
  TEXTO,
  BOOLEAN,
  CHIPS
}

export interface FonteDadosProxyParametroConfig {
  nome?: string;
  rotulo?: string;
  tipo?: FonteDadosProxyParametroTipo;
  obrigatorio?: boolean;
  titulo?: string;
  valor?: any;
}
